// extracted by mini-css-extract-plugin
module.exports = {"commentBox":"commentBox_commentBox__29Yqu","showHide":"commentBox_showHide__Y_kZN"};